/*
 * GroupMembers Messages
 *
 * This contains all the text for the AdminGroups component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  groups: {
    id: 'app.components.AdminGroups.groups',
    defaultMessage: 'Groups',
  },
  adminGroups: {
    id: 'app.components.AdminGroups.adminGroups',
    defaultMessage: 'Administrative Groups',
  },
  employee: {
    id: 'app.components.UsersByRole.employee',
    defaultMessage: 'Employees',
  },
  parent: {
    id: 'app.components.UsersByRole.parent',
    defaultMessage: 'Parents',
  },
  student: {
    id: 'app.components.UsersByRole.student',
    defaultMessage: 'Students',
  },
  staff: {
    id: 'app.components.UsersByRole.staff',
    defaultMessage: 'Staff Members',
  },
  name: {
    id: 'app.common.name',
    defaultMessage: 'Name',
  },
  active: {
    id: 'app.components.AdminUsers.account',
    defaultMessage: 'Account',
  },
  membership: {
    id: 'app.components.AdminGroups.membership',
    defaultMessage: 'Membership',
  },
  noMembers: {
    id: 'app.components.UsersByRole.noMembers',
    defaultMessage: 'No members',
  },
  membersAdded: {
    id: 'app.components.UsersByRole.membersAdded',
    defaultMessage: 'New members have been added',
  },
  add: {
    id: 'app.common.add',
    defaultMessage: 'Add',
  },
  select: {
    id: 'app.components.AdminGroups.select',
    defaultMessage: 'Select',
  },
  confirmRemoveMember: {
    id: 'app.components.AdminGroups.confirmRemoveMember',
    defaultMessage: 'Remove member {accountName}?',
  },
  memberRemoved: {
    id: 'app.components.AdminGroups.memberRemoved',
    defaultMessage: 'Member removed',
  },
  addAll: {
    id: 'app.components.AdminGroups.addAll',
    defaultMessage: 'Add All',
  },
  confirmAddAll: {
    id: 'app.components.AdminGroups.confirmAddAll',
    defaultMessage: 'Add all {count} {type}?',
  },
  activeStudents: {
    id: 'app.components.AdminGroups.activeStudents',
    defaultMessage: '{activeCount}/{totalCount} active students',
  },
  studentsUseSocs: {
    id: 'app.components.AdminGroups.studentsUseSocs',
    defaultMessage: 'Do you want the students to be able to use Social Schools themselves?',
  },
  inviteStudents: {
    id: 'app.components.AdminUsers.inviteStudents',
    defaultMessage: 'Invite Students',
  },
  class: {
    id: 'app.components.AdminGroups.class',
    defaultMessage: 'Class',
  },
  distributePrints: {
    id: 'app.components.AdminGroups.distributePrints',
    defaultMessage: 'Print the invitations so that you can hand them out in class.',
  },
  printCount: {
    id: 'app.components.AdminGroups.printCount',
    defaultMessage: '{count, plural, one {# invitation} other {# invitations}}  will be printed',
  },
  invitePrintButton: {
    id: 'app.components.AdminUsers.invitePrintButton',
    defaultMessage: 'Open Page',
  },
  connectedParentsEmail: {
    id: 'app.components.AdminGroups.connectedParentsEmail',
    defaultMessage: 'Connected parents/guardians will receive an email with the activation code for their child.',
  },
  numberInvitationsStudents: {
    id: 'app.components.AdminGroups.numberInvitationsStudents',
    defaultMessage: '{parentCount, plural, one {# invitation} other {# invitations}} will be sent for {studentCount, plural, one {# student} other {# students}}',
  },
  countUnconnected: {
    id: 'app.components.AdminGroups.countUnconnected',
    defaultMessage: 'There are {unconnectedCount} students who do not have connected parents/guardians',
  },
  send: {
    id: 'app.common.send',
    defaultMessage: 'Send',
  },
  invitationsSent: {
    id: 'app.components.AdminUsers.invitationsSent',
    defaultMessage: 'The {count, plural, one {# invitation has} other {# invitations have}} been sent',
  },
  inviteParents: {
    id: 'app.components.AdminUsers.inviteParents',
    defaultMessage: 'Invite Parents',
  },
  username: {
    id: 'app.components.EditAccount.username',
    defaultMessage: 'Username',
  },
  updateAvatar: {
    id: 'app.components.AdminUsers.updateAvatar',
    defaultMessage: 'Update Avatar',
  },
  resetPassword: {
    id: 'app.components.AdminUsers.resetPassword',
    defaultMessage: 'Reset Password',
  },
  removeMember: {
    id: 'app.components.AdminGroups.removeMember',
    defaultMessage: 'Remove from Group',
  },
  printLetter: {
    id: 'app.components.AdminUsers.printLetter',
    defaultMessage: 'Print Activation Letter',
  },
  grade: {
    id: 'app.components.AdminUsers.grade',
    defaultMessage: 'Grade',
  },
  studentCount: {
    id: 'app.components.AdminUsers.studentCount',
    defaultMessage: 'Number of students',
  },
});
